var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFingerprintScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.57,
    height: 19.52,
    viewBox: "0 0 17.57 19.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fingerprint-scan"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.7,19.5a8.68,8.68,0,1,1,7.9-9.4A8.66,8.66,0,0,1,13.7,19.5ZM12.4,3.4a7.42,7.42,0,1,0,8,6.8A7.53,7.53,0,0,0,12.4,3.4Z",
    transform: "translate(-4.17 -2.07)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,21.2l1.8-2.1a.71.71,0,1,0-1.1-.9L4.5,20.3a.67.67,0,0,0,.1,1c.2.1.3.2.5.2S5.4,21.3,5.6,21.2Z",
    transform: "translate(-4.17 -2.07)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_127",
    "data-name": "Capa 127"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.1,10.3c.2,1.1.3,2.3.5,3.4v.4c0,.3-.2.4-.4.5s-.5-.1-.5-.4a5.07,5.07,0,0,1-.2-1.3,26.6,26.6,0,0,1-.3-2.8,4.78,4.78,0,0,1,3.1-4.8,8.63,8.63,0,0,1,3.6-.8,5.62,5.62,0,0,1,3.9,1.9,6.33,6.33,0,0,1,1.6,3.4.53.53,0,0,1-.4.7c-.3.1-.5-.1-.6-.5a6.6,6.6,0,0,0-1.2-2.7,4.49,4.49,0,0,0-4.7-1.7,10.64,10.64,0,0,0-2.5.9A5.31,5.31,0,0,0,8.7,7.8a3.29,3.29,0,0,0-.5,1.8A2,2,0,0,0,8.1,10.3Z",
    transform: "translate(-4.17 -2.07)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1,13.6v.6a.56.56,0,0,1-.5.6c-.3,0-.5-.2-.5-.6a10.55,10.55,0,0,0-.2-2.5A6.42,6.42,0,0,0,15,8.3a2.46,2.46,0,0,0-2.7-.5,3.13,3.13,0,0,0-1,.5,2.44,2.44,0,0,0-1.1,2.5c.1.8.3,1.6.4,2.4a5.93,5.93,0,0,1,0,2.3l-.3.6a.48.48,0,0,1-.6.2c-.2-.1-.4-.4-.3-.6a3.85,3.85,0,0,0,.1-2.8c-.1-.8-.3-1.5-.4-2.3a3.43,3.43,0,0,1,2-3.4,4.66,4.66,0,0,1,2-.6,3.69,3.69,0,0,1,2.7,1.1,7.35,7.35,0,0,1,2,3.8A6.14,6.14,0,0,1,18.1,13.6Z",
    transform: "translate(-4.17 -2.07)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2,13.7",
    transform: "translate(-4.17 -2.07)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4,15v.6c0,.4-.2.6-.5.6s-.5-.2-.5-.6a7.57,7.57,0,0,0-.1-1.5,7.81,7.81,0,0,0-.9-3.4,1.79,1.79,0,0,0-.5-.7.9.9,0,0,0-1.5.5,3.3,3.3,0,0,0,0,1.4l.3,2.4a6.52,6.52,0,0,1-.2,2.4.5.5,0,0,1-.8.3.48.48,0,0,1-.2-.6,6.93,6.93,0,0,0,.1-3.2,10.14,10.14,0,0,1-.2-2.5,2,2,0,0,1,2.2-2,2.27,2.27,0,0,1,1.6,1.1,6,6,0,0,1,.9,2.2C16.2,13,16.4,14,16.4,15Z",
    transform: "translate(-4.17 -2.07)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,14.9c-.1.5-.1,1.1-.2,1.7a.56.56,0,0,1-.6.5.44.44,0,0,1-.4-.6c.1-.6.1-1.2.2-1.8a7.83,7.83,0,0,0-.4-2.6c0-.1-.1-.3,0-.4a.46.46,0,0,1,.5-.4.51.51,0,0,1,.5.4c.1.6.3,1.2.4,1.8A3.27,3.27,0,0,0,14.6,14.9Z",
    transform: "translate(-4.17 -2.07)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprintScan);
export default __webpack_public_path__ + "static/media/fingerprint-scan.1dedb3a75e4a1e72b874e4e83b705729.svg";
export { ForwardRef as ReactComponent };